import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { StorageService } from 'src/app/services/storage/storage.service';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'route-fortify-v2-logout',
  templateUrl: './fortify-v2-logout.component.html',
  styleUrls: ['./fortify-v2-logout.component.scss']
})
export class FortifyV2LogoutComponent implements OnInit {

  subscription! : Subscription;

  constructor(
    private auth: AuthService,
    private storage: StorageService,
  ) { 
    //
    //  1. Subscribe to Auth Service token$.
    // 
    this.subscription = 
    this.auth.getToken$()
    .subscribe( res => {
      if (res != (undefined || null )) {
        this.auth.logout();
      }
    })

    let accessToken = this.auth.getAccessToken();
    if ( accessToken != null ) {
      this.auth.discoverCodeForLogout();
    }
    if ( accessToken == null ) {
      //
      // You can only have one configured Login at a time. else 500.
      this.storage.setItem('logout-fortify-v2', true);
      this.auth.loginCode();
    }

  }

  ngOnInit() {
    document.body.style.paddingTop = "0px"; // unit measured in Edge.
  }

}
